import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-twitch',
    template: `
            <svg [class]="class" stroke="currentColor" fill="currentColor" viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg">
                <path d="M170.666667 85.333333 938.666667 85.333333 938.666667 597.333333 725.333333 810.666667 554.666667 810.666667 426.666667 938.666667 298.666667 938.666667 298.666667 810.666667 85.333333 810.666667 85.333333 256 170.666667 85.333333M853.333333 554.666667 853.333333 170.666667 256 170.666667 256 682.666667 384 682.666667 384 810.666667 512 682.666667 725.333333 682.666667 853.333333 554.666667M640 298.666667 725.333333 298.666667 725.333333 512 640 512 640 298.666667M512 298.666667 512 512 426.666667 512 426.666667 298.666667 512 298.666667Z"/>
            </svg>
    `,
    standalone: true
})
export class IconTwitch {
    @Input() class: any = '';

}
